module.exports = __webpack_public_path__ + "img/fire.d1d29c68.svg";